<template>
  <article class="order-history">
    <header>
      <div class="order-history-title">
        <figure class="paper__figure">
          <img src="@/assets/images/img-order-clip.png" />
        </figure>
        <BaseTitle :title="t('title.order_history')">
          <template #icon>
            <img src="@/assets/images/icon-order.svg" alt="주문 목록 아이콘" />
          </template>
        </BaseTitle>
      </div>
    </header>
    <main>
      <ul class="order-history__ul">
        <li v-for="orderItem in orderHistoryItems" :key="orderItem.Key">
          <OrderHistoryItem :order-item="orderItem" />
        </li>
      </ul>
    </main>
    <footer :class="{ 'pre-order': configStore.usePreOrder && remainingPaymentSummary.amount > 0 }">
      <div class="order-history__summary">
        <div>
          <div class="order-history__count">
            <span>{{ totalMenuTypeQty }}</span> {{ t('label.cart_count_type') }} <span>{{ totalQty }}</span>
            {{ t('label.cart_count_piece') }}
          </div>
        </div>
        <div class="summary__area1">
          <div>
            <span class="amount__text">{{ t('label.order_amount') }}</span>
            <span class="amount__price">{{ formatCurrency(orderAmount) }}</span>
          </div>
          <div v-if="configStore.usePreOrder">
            <span class="amount__text">{{ t('label.remaining_payment_amount') }}</span>
            <span class="amount__price">{{ formatCurrency(remainingPaymentSummary.amount) }}</span>
          </div>
        </div>
      </div>
      <div class="order-history__button">
        <BaseButtonGroup>
          <BaseButton v-if="isReceiptButtonShown" class="outline" @button-click="handleReceiptClick">
            <template #icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="32"
                height="35"
                viewBox="0 0 32 35"
              >
                <defs>
                  <clipPath id="clip-path">
                    <rect width="32" height="35" transform="translate(0 0)" fill="#fff" />
                  </clipPath>
                </defs>
                <g transform="translate(-0.4 0.131)">
                  <g transform="translate(0.4 -0.131)">
                    <path
                      d="M31.919,18.266c-1.607-1.718-6.026-6.085-7.6-7.633L21.372,12.1l7.7,7.729a1.95,1.95,0,0,1-.621,3.234c-1.278.718-8.828,4.877-10.555,5.829a4.859,4.859,0,0,0-1.365-2.814c-.775-.8-10.107-10.656-12.434-13.259A2.183,2.183,0,0,1,3.606,10.2,2.753,2.753,0,0,1,5.97,8.871a2.526,2.526,0,0,1,2.56,1.755A2.1,2.1,0,0,1,7.5,13.061l2.2,2.346L22.582,8.984a4.582,4.582,0,0,0,1.537-6.52A5.93,5.93,0,0,0,19.2,0C17.234,0,17.887-.023,3.388,6.465A5.1,5.1,0,0,0,0,11.09a5.381,5.381,0,0,0,1.469,3.593c2.359,2.592,12.5,13.269,12.588,13.373a2.033,2.033,0,0,1,.248,2.417,2.653,2.653,0,0,1-2.362,1.28A2.525,2.525,0,0,1,9.383,30a2.025,2.025,0,0,1,1-2.389L8.271,25.375A5.021,5.021,0,0,0,5.995,28.9c-.383,3.185,2.521,5.768,5.972,5.768a6.717,6.717,0,0,0,3.043-.737l15.581-8.59a4.954,4.954,0,0,0,2.466-4.185,4.216,4.216,0,0,0-1.137-2.894M18.214,3.109a2.706,2.706,0,0,1,1.007-.194A2.341,2.341,0,0,1,21.275,4a1.912,1.912,0,0,1-.906,2.762l-8.424,4.172a5.044,5.044,0,0,0-2.4-3.947Zm5.378,14.526-7.98,4.078-1.066-1.128,7.942-4.056,1.1,1.107m-11.5.344,7.851-4.012,1.1,1.109-7.889,4.032-1.066-1.13m14.032,2.194L18.054,24.3l-1.066-1.128,8.029-4.1,1.1,1.108"
                      transform="translate(-0.4 0.132)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </template>
            <span>{{ t('button.receipt_request') }}</span>
          </BaseButton>
          <BaseButton v-if="isPaymentButtonShown" class="outline" @button-click="handlePaymentClick">
            <template #icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="32"
                height="35"
                viewBox="0 0 32 35"
              >
                <defs>
                  <clipPath id="clip-path">
                    <rect width="32" height="35" transform="translate(0 0)" fill="#fff" />
                  </clipPath>
                </defs>
                <g transform="translate(-0.4 0.131)">
                  <g transform="translate(0.4 -0.131)">
                    <path
                      d="M31.919,18.266c-1.607-1.718-6.026-6.085-7.6-7.633L21.372,12.1l7.7,7.729a1.95,1.95,0,0,1-.621,3.234c-1.278.718-8.828,4.877-10.555,5.829a4.859,4.859,0,0,0-1.365-2.814c-.775-.8-10.107-10.656-12.434-13.259A2.183,2.183,0,0,1,3.606,10.2,2.753,2.753,0,0,1,5.97,8.871a2.526,2.526,0,0,1,2.56,1.755A2.1,2.1,0,0,1,7.5,13.061l2.2,2.346L22.582,8.984a4.582,4.582,0,0,0,1.537-6.52A5.93,5.93,0,0,0,19.2,0C17.234,0,17.887-.023,3.388,6.465A5.1,5.1,0,0,0,0,11.09a5.381,5.381,0,0,0,1.469,3.593c2.359,2.592,12.5,13.269,12.588,13.373a2.033,2.033,0,0,1,.248,2.417,2.653,2.653,0,0,1-2.362,1.28A2.525,2.525,0,0,1,9.383,30a2.025,2.025,0,0,1,1-2.389L8.271,25.375A5.021,5.021,0,0,0,5.995,28.9c-.383,3.185,2.521,5.768,5.972,5.768a6.717,6.717,0,0,0,3.043-.737l15.581-8.59a4.954,4.954,0,0,0,2.466-4.185,4.216,4.216,0,0,0-1.137-2.894M18.214,3.109a2.706,2.706,0,0,1,1.007-.194A2.341,2.341,0,0,1,21.275,4a1.912,1.912,0,0,1-.906,2.762l-8.424,4.172a5.044,5.044,0,0,0-2.4-3.947Zm5.378,14.526-7.98,4.078-1.066-1.128,7.942-4.056,1.1,1.107m-11.5.344,7.851-4.012,1.1,1.109-7.889,4.032-1.066-1.13m14.032,2.194L18.054,24.3l-1.066-1.128,8.029-4.1,1.1,1.108"
                      transform="translate(-0.4 0.132)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </template>
            <span>{{ t('button.pay') }}</span>
          </BaseButton>
          <BaseButton @button-click="handleConfirmClick">
            <template #icon>
              <img src="@/assets/images/icon-check-white.svg" alt="확인 아이콘" />
            </template>
            {{ t('button.confirm') }}
          </BaseButton>
        </BaseButtonGroup>
      </div>
    </footer>
  </article>
</template>

<script setup lang="ts">
  import * as Android from '@/api/android';
  import BaseButton from '@/components/base/BaseButton.vue';
  import BaseButtonGroup from '@/components/base/BaseButtonGroup.vue';
  import BaseTitle from '@/components/base/BaseTitle.vue';
  import OrderHistoryItem from '@/components/OrderHistoryItem.vue';
  import UserError from '@/error';
  import OrderItem from '@/interfaces/OrderItem';
  import PaymentSummary from '@/interfaces/PaymentSummary';
  import { logger } from '@/logger';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { useModalStore } from '@/stores/modal';
  import { useOrderStore } from '@/stores/order';
  import { formatCurrency } from '@/utils';
  import equal from 'deep-equal';
  import { v4 as uuid } from 'uuid';
  import { computed, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import OrderReceipt from './OrderReceipt.vue';
  import Payment from './Payment.vue';

  const emits = defineEmits(['close']);

  const { t } = useI18n();
  const commonStore = useCommonStore();
  const modalStore = useModalStore();
  const configStore = useConfigStore();
  const orderStore = useOrderStore();

  const orderHistoryItems = ref<OrderItem[]>([]);
  // 주문 금액
  const orderAmount = ref(0);
  // 결제 금액
  const paidAmount = ref(0);
  // 남은 결제 요약 정보
  const remainingPaymentSummary = ref<PaymentSummary>({
    amount: 0,
    taxFree: 0,
    tax: 0,
    deposit: 0,
    preTip: 0,
    splits: [],
  });

  // 주문 메뉴 가지수
  const totalMenuTypeQty = computed(() => orderHistoryItems.value.length);

  // 주문 수량
  const totalQty = computed(() => orderHistoryItems.value.reduce((acc, orderItem) => acc + (orderItem.QTY || 1), 0));

  // 영수증요청 버튼 표시 여부
  const isReceiptButtonShown = computed(() => {
    // 전자 영수증 종이 영수증 모두 사용하지 않는다면 false 반환
    if (!configStore.useReceipt) return false;

    if (configStore.config.IsPrepaidOrderKeepingUsed && configStore.config.IsReceiptPrintUsed && paidAmount.value > 0) {
      // 선불주문유지옵션 사용 && 영수증 출력 옵션 사용 && 결제 금액이 있는 경우 영수증 버튼 표시
      return true;
    } else if (!configStore.config.IsPrepaidOrderKeepingUsed && orderAmount.value === paidAmount.value) {
      // 선불주문유지옵션 미사용 && 주문 금액과 결제 금액이 동일한 경우 영수증 버튼 표시
      return true;
    }
    return false;
  });

  // 결제하기 버튼 표시 여부
  // 선주문 후결제 사용 && 남은 결제 금액이 0보다 큰 경우
  const isPaymentButtonShown = computed(() => configStore.usePreOrder && remainingPaymentSummary.value.amount > 0);

  onMounted(() => {
    logger.info('[OrderHistory] onMounted');
    setHistoryData();
  });

  /** POS에서 주문 조회하여 내역 데이터 세팅 */
  const setHistoryData = async () => {
    const loadingId = commonStore.showLoading();
    try {
      // 주문 조회
      const response = await Android.getOrderDataAsync();

      // 주문 조회 성공 여부 검사
      if (response.RET_CODE !== 0) throw new UserError(response.RET_MSG);

      // 주문이 존재하는 경우 데이터 세팅
      if (response.DATA) {
        // 주문 아이템 세팅
        if (response.DATA.Items) {
          // 동일메뉴 합친 후 주문내역 데이터에 세팅
          setOrderHistoryItems(response.DATA.Items);
        }

        // 주문금액 세팅
        orderAmount.value = response.DATA.TotalPaymentValue;

        // 결제 금액 합산 데이터 세팅
        //const paidAmount = response.DATA.Payments?.reduce((acc, payment) => acc + payment.PayAmt, 0) || 0;
        let paidTotal = 0;
        let paidTaxFree = 0;
        let paidTax = 0;
        let paidDeposit = 0;
        let paidPreTip = 0;
        response.DATA.Payments?.forEach((payment) => {
          // 카드결제(PY101) 취소인 경우 매출 금액이 양수이고, AppType이 2로 들어오기 때문에 차감 처리
          if (payment.PaymentSection === 'PY101' && payment.AppType === '2') {
            paidTotal -= payment.PayAmt;
            paidTaxFree -= payment.FreeAmount;
            paidTax -= payment.Tax;
            paidDeposit -= payment.Deposit;
            paidPreTip -= payment.PreTip;
          } else {
            paidTotal += payment.PayAmt;
            paidTaxFree += payment.FreeAmount;
            paidTax += payment.Tax;
            paidDeposit += payment.Deposit;
            paidPreTip += payment.PreTip;
          }
        });

        // 결제 금액 세팅
        paidAmount.value = paidTotal;

        // 선주문 후결제 옵션을 사용 중이고, 주문 금액보다 결제금액이 작은 경우 결제할 금액 설정
        if (configStore.usePreOrder && orderAmount.value > paidTotal) {
          remainingPaymentSummary.value = {
            amount: orderAmount.value - paidTotal,
            taxFree: response.DATA.FreeAmount - paidTaxFree,
            tax: response.DATA.Tax - paidTax,
            deposit: response.DATA.Deposit - paidDeposit,
            preTip: response.DATA.PreTip - paidPreTip,
            splits: [],
          };
        }
      }
    } finally {
      commonStore.hideLoading(loadingId);
    }
  };

  /**
   * POS에서 조회한 주문 데이터에서 동일메뉴 합산 후 주문내역 데이터에 세팅
   * @param originalData POS에서 조회한 원본 주문 데이터
   */
  const setOrderHistoryItems = (originalData: OrderItem[]) => {
    const tempArrayForCompare: any[] = [];
    const result: OrderItem[] = [];
    originalData.forEach((item) => {
      const findCompareItem = tempArrayForCompare.find((x) => x.ITEM_CODE === item.ITEM_CODE);

      // 동일 메뉴 비교를 위해 비교할 객체 복사 (비교하면 안되는 항목 삭제 후 비교하기 위해)
      const compareItem: any = {
        ITEM_CODE: item.ITEM_CODE,
        Price: item.Price,
        DiscountAmt: item.DiscountAmt,
        Modifier_Add_Price: item.Modifier_Add_Price,
        SetItem_Add_Price: item.SetItem_Add_Price,
        Modifier: item.Modifier?.map((modifier) => {
          return {
            Modifier_Entity_Code: modifier.Modifier_Entity_Code,
            Add_Section: modifier.Add_Section,
            Add_Price: modifier.Add_Price,
          };
        }),
        SetMenu: item.SetMenu?.map((setMenu) => {
          return {
            SetItem_Level: setMenu.SetItem_Level,
            ITEM_CODE: setMenu.ITEM_CODE,
            Price: setMenu.Price,
            QTY: setMenu.QTY,
          };
        }),
      };

      // 동일 메뉴 비교를 위해 토핑 옵션 정렬
      compareItem.Modifier?.sort((a: any, b: any) => {
        return a.Modifier_Entity_Code.localeCompare(b.Modifier_Entity_Code);
      });

      // 동일 메뉴 비교를 위해 세트메뉴 옵션 정렬
      compareItem.SetMenu?.sort((a: any, b: any) => {
        return a.SetItem_Level.localeCompare(b.SetItem_Level) || a.ITEM_CODE.localeCompare(b.ITEM_CODE);
      });

      if (!findCompareItem || !equal(findCompareItem, compareItem)) {
        // 처음 조회되는 메뉴이거나 객체가 다른 경우 비교 리스트에 추가
        tempArrayForCompare.push(compareItem);
        result.push(item);
      } else {
        // 결과 리스트에 같은 메뉴가 이미 존재하는 경우 수량 합산 및 주문일자 업데이트
        const findItem = result.find((x) => x.ITEM_CODE === item.ITEM_CODE);
        if (findItem) {
          findItem.Key == uuid();
          findItem.QTY += item.QTY;
          findItem.Amt += item.Amt;
          findItem.DiscountAmt += item.DiscountAmt;
          findItem.RegDate = item.RegDate;
        }
      }
    });

    orderHistoryItems.value = result;
  };

  /** 영수증 버튼 클릭 */
  const handleReceiptClick = () => modalStore.openFullScreenModal(OrderReceipt, { fromOrderHistory: true });

  /** 결제 버튼 클릭 */
  const handlePaymentClick = async () => {
    // 테이블 사용 중인지 검사
    await orderStore.fetchOrder(false);

    modalStore.openFullScreenModal(Payment, { isPreOrder: true, paymentSummary: remainingPaymentSummary.value });
  };

  /** 확인 버튼 클릭  */
  const handleConfirmClick = () => emits('close');
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .order-history {
    display: grid;
    grid-template-rows: auto 1fr auto;
    position: relative;
    height: 100vh;
    padding: 2.9851vw 3.7313vw 0 3.7313vw;
    background: transparent linear-gradient(180deg, #b5b5b5 0%, #dadada 100%) 0 0 no-repeat padding-box;
    header {
      padding: 2.9851vw 3.7313vw 0;
      background: #fff;
      box-shadow: vars.$base-box-shadow-black;
      .order-history-title {
        display: flex;
        align-items: center;
        gap: 0.7463vw;
        padding-bottom: 1.4925vw;
        border-bottom: 0.0746vw solid var(--border-color-secondary);
        .paper__figure {
          position: absolute;
          top: 1.1194vw;
          left: 50%;
          transform: translateX(-50%);
          width: 19.1791vw;
          img {
            width: 100%;
          }
        }
        h1 {
          font-size: 2.0896vw;
          @media (max-width: vars.$sm) {
            font-size: 16px;
          }
        }
      }
    }
    main {
      overflow-y: auto;
      height: auto;
      padding: 0 3.7313vw 1.4925vw;
      background: #fff;
      box-shadow: vars.$base-box-shadow-bottom-black;
      .order-history__ul {
        li {
          padding: 1.194vw 0 0.8955vw 0;
        }
        li + li {
          border-top: 0.0746vw dashed var(--border-color-primary);
        }
      }
    }
    footer {
      display: grid;
      grid-template-columns: 1fr 59.7015vw;
      align-items: center;
      justify-content: space-between;
      gap: 1.4925vw;
      margin: 1.4925vw 0;
      @media (max-width: vars.$sm) {
        grid-template-columns: none;
        grid-template-rows: 1fr 1fr;
        justify-content: initial;
        gap: 10px;
        margin: 10px 0;
      }
      &.pre-order {
        grid-template-columns: 1fr 44.7761vw;
      }
      .order-history__summary {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: space-between;
        @media (max-width: vars.$sm) {
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
        }
        .summary__area1 {
          display: flex;
          flex-direction: row;
          gap: 1.4925vw;
          width: 100%;
          @media (max-width: vars.$sm) {
            justify-content: space-between;
          }
        }
        .order-history__count {
          font-size: 1.8657vw;
          font-weight: 700;
          @media (max-width: vars.$sm) {
            font-size: 16px;
          }
          span {
            font-size: 2.3881vw;
            color: var(--point-color-secondary);
            @media (max-width: vars.$sm) {
              font-size: 18px;
            }
          }
        }
        .amount__text {
          font-size: 1.8657vw;
          font-weight: 700;
          margin-right: 1.0448vw;
          @media (max-width: vars.$sm) {
            font-size: 16px;
          }
        }
        .amount__price {
          font-size: 2.3881vw;
          font-weight: 700;
          color: var(--point-color-secondary);
          @media (max-width: vars.$sm) {
            font-size: 18px;
          }
        }
      }
      .order-history__button {
        flex: 1;
        @media (max-width: vars.$sm) {
          width: 100%;
        }
        .BaseButton__group {
          display: flex;
          justify-content: flex-end;
          .BaseButton {
            flex: 0 1 29.8507vw !important;
            @media (max-width: vars.$sm) {
              flex: 1 !important;
            }
          }
        }
      }
    }
  }
</style>
